import {Storage} from "@/services/Storage";
import axios from "axios";
import router from "@/router";

export default {
    name: 'accounts',
    state: {
        debtors : [],
    },
    getters: {
        getDebtors: (state) =>state.debtors,
        getDebtorByID : (state) => (id) => {
            let customer = state.debtors.find(debtor => debtor.Id === id)
            if (customer){
                return customer.Name;
            }
            return id;
        }
    },
    mutations: {
        setDebtors : (state , data) => state.debtors = data
    },
    actions: {
        getAllDebtors : async (context,payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(franchiseTomcatApi + `debtor/${store.StoreDB}/search`,payload)
                .then(({data})=> context.commit('setDebtors', data))
                .catch((err) => errorHandler.tomcatError(err))
        },
        createDebtor : async (context , payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(serverApi + `debtor/${store.StoreDB}`,payload)
                .then(({data})=> context.dispatch(`getAllDebtors`,{
                    Name: "",
                    tpin: "",
                    contact: ""
                }).then(()=>data))
                .catch((err) => errorHandler.tomcatError(err))
        },

        printDebtorStatement : async (context,id) => {
            let store = await Storage.getDefaultStore();
            return axios.get(franchiseTomcatApi + `getStatement/${store.StoreDB}?ID=${id}`,)
                .then(({data})=> {
                    try {
                        Printing.printStatement(JSON.stringify(data))
                    }catch (e) {}
                }).catch((err) => errorHandler.tomcatError(err))
        },
        makeDebtorPayment: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            let user = await Storage.getCurrentUser();
            payload.User = user.Username;
            let obj = {
                route : `debtor/${store.StoreDB}/makeCashierPayment`,
                jsonBody : JSON.stringify(payload)
            }
            return axios.post(backOfficeApiPOST , obj)
                .then(({data}) => {
                    try {
                        Printing.printReceipt(JSON.stringify(data))
                    }catch (e) {}
                    context.commit(`setCustomer`,'')
                    responses.showSuccess(`Payment Successfully Made`)
                    return router.push({ name : 'pos' })
                }).catch((err) => errorHandler.tomcatError(err,true))
        },

        firstKazangAccountPaymentStep : async (context,payload) => {
            let store = await Storage.getDefaultStore();
            let network = await context.dispatch('checkCustomerNetwork', payload.customerContact);
            // Fix for TD-XXX: Imeis.getDeviceImei() always returns a non-empty string ('unknown' fallback)
            // so the `pc=` query param is never null/empty. See kazang_module.js firstKazangPaymentStep.
            let deviceId = await Imeis.getDeviceImei();
            let requestPayload = {
                localid: generateUUID(),
                amount: Number(payload.PayedAmount.toFixed(2)),
                msisdn: payload.customerContact,
                network: network
            };
            let url = `${serverApi}api/payments/kazang/${store.StoreDB}?pc=${deviceId}`;
            return axios.post(url, requestPayload)
                .then(({data}) => {
                    let response = data && data.response ? data.response : data;
                    let responseCode = response ? (response.Response ?? response.response) : null;
                    if (!response || String(responseCode) !== '0') {
                        let printMessage = response ? (response.Print ?? response.print) : null;
                        throw new Error(printMessage || 'Kazang payment failed');
                    }
                    let localID = (data && (data.LocalID || data.localID))
                        || (response && response.secondRefrence)
                        || requestPayload.localid;
                    return context.dispatch('makeDebtorPayment', payload)
                        .then(() => ({success: true, LocalID: localID}));
                }).catch((err) => {
                    errorHandler.tomcatError(err, true)
                    return Promise.reject(err);
                })
        },

        secondKazangAccountPaymentStep : async (context,firstStepResponse) => {
            let store = await Storage.getDefaultStore();
            let network = await context.dispatch('checkCustomerNetwork', firstStepResponse.customerContact);
            let route = ''

            switch (network) {
                case 'MTN':
                    route = '/mtnApprove';
                    break
                case 'Airtel':
                    route = '/airtelApprove';
                    break
                default:
                    route = '/zamtelApprove'
                    break
            }
            let url = kazangApi + `pay/${store.StoreDB}${route}`;
            return axios.post(url, JSON.parse(firstStepResponse.SecondStepPayload))
                .then(({data}) => {
                    if (!data.Error) {
                        if (!data.approved) {
                            return {
                                Error: 'Not Confirmed'
                            }
                        }
                        return context.dispatch('makeDebtorPayment', firstStepResponse.paymentData)
                    }
                    return data
                }).catch((err) => {
                    context.commit('clearKazangSession')
                    errorHandler.tomcatError(err)
                })
        },
    }
}
